// @utils
import { create } from "zustand";

export const useVariation = create((set) => ({
  variation: "EHEX & PHEX",
  setToPHEX: () => set({ variation: "PHEX" }),
  setToEHEX: () => set({ variation: "EHEX" }),
  setToBoth: () => set({ variation: "EHEX & PHEX" }),
}));
